var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { CardVeiculo } from "../../components/Veiculos/CardVeiculo";
import { useAuth } from "../../hooks/useAuth";
import { obterVeiculos } from "../../services/veiculos.service";
import { FixedMenu } from "../../components/FixedMenu";
export var Veiculos = function () {
    var servico = useParams().servico;
    var userInfo = useAuth().userInfo;
    var _a = useState(), veiculos = _a[0], setVeiculos = _a[1];
    var _b = useState(), erro = _b[0], setErro = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        var fetchVeiculos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            pagina: "1",
                        };
                        return [4 /*yield*/, obterVeiculos(payload)];
                    case 1:
                        response = _b.sent();
                        setVeiculos(response);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        setErro((_a = error_1.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao buscar veículos");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchVeiculos();
    }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Meus Ve\u00EDculos", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Meus Ve\u00EDculos" }), servico && veiculos && veiculos[0].placa ? (_jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsx(ContainerLayout, { children: veiculos === null || veiculos === void 0 ? void 0 : veiculos.map(function (veiculo) { return (_jsx(CardVeiculo, { veiculo: veiculo, servico: servico }, veiculo.placa)); }) }) }))) : (_jsx(ContainerLayout, { children: _jsx(NaoEncontrado, { subtitulo: "O sistema n\u00E3o localizou nenhum ve\u00EDculo relacionado ao cpf autenticado." }) })), erro && _jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" })] }));
};
